module.exports = __webpack_public_path__ + "img/timeline-d6d350.png";